import { tw } from "@careinfo/tailwind";
import dayjs from "dayjs";
import { Fragment } from "react";

export default function LedgerTable({ data }: { data: any[] }) {
  return (
    <tbody>
      {data.map((product) => {
        const openingQty = product.account.opening_quantity ?? 0;
        const openingBalance = product.account.opening_balance ?? 0;
        const openingRate = product.account.opening_rate ?? 0;

        const billItems = product.bill_items || [];

        const receivedTotal = billItems
          .filter((b) => !b.is_sales)
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

        const deliveredTotal = billItems
          .filter((b) => b.is_sales)
          .reduce((sum, b) => sum + Number(b.quantity || 0), 0);

        const closingQty = openingQty + receivedTotal - deliveredTotal;
        const openingValue = Number(openingRate * openingQty).toFixed(2);

        return (
          <Fragment key={product.account.id}>
            <tr className={tw`bg-white font-semibold`}>
              <td className={tw`py-2 px-5 text-primary`} colSpan={2}>
                {product.account.name}
              </td>
              <td></td>
              <td className={tw`py-2 px-5 text-primary`}>
                {product.account.unit}
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5 font-semibold`}>Opening Balance</td>
              <td className={tw`py-2 px-5 `}>
                <div className={tw`flex justify-around`}>
                  <span>{openingQty.toFixed(2)}</span>
                  <span>
                    {Number(openingRate.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span>
                    {Number(openingValue).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </td>
              <td></td>
            </tr>
            {billItems.map((bill) => {
              const qty = Number(bill?.quantity || 0);
              const rate = Number(bill?.rate || 0);
              const total = Number(bill?.total || 0);

              return (
                <tr key={bill.id}>
                  <td className={tw`py-2 px-5`}>
                    {dayjs(bill.bill.voucher_date).format("YY/MM/DD")}
                  </td>
                  <td className={tw`py-2 px-5`}>
                    {dayjs(bill.bill.miti).format("YY/MM/DD")}
                  </td>
                  <td className={tw`py-2 px-5`}>{bill.bill.bill_no}</td>
                  <td className={tw`py-2 px-5`}>{bill.bill.party}</td>

                  <td className={tw`py-2 px-5`}>
                    <div className={tw`flex justify-around w-full`}>
                      <span>{!bill.is_sales ? qty.toFixed(2) : ""}</span>
                      <span>
                        {!bill.is_sales
                          ? Number(rate.toFixed(2)).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : ""}
                      </span>
                      <span>
                        {!bill.is_sales
                          ? Number(total.toFixed(2)).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : ""}
                      </span>
                    </div>
                  </td>
                  <td className={tw`py-2 px-5`}>
                    <div className={tw`flex justify-around w-full`}>
                      <span>{bill.is_sales ? qty.toFixed(2) : ""}</span>
                      <span>
                        {bill.is_sales
                          ? Number(rate.toFixed(2)).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : ""}
                      </span>
                      <span>
                        {bill.is_sales
                          ? Number(total.toFixed(2)).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : ""}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}

            <tr className={tw`bg-gray-100 font-semibold`}>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5`}>Total</td>
              <td className={tw`py-2 `}>
                <div className={tw`flex justify-around w-full`}>
                  <span>
                    {Number(receivedTotal.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span></span>
                  <span></span>
                </div>
              </td>
              <td className={tw`py-2  `}>
                <div className={tw`flex justify-around w-full`}>
                  <span>
                    {Number(deliveredTotal.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span></span>
                  <span></span>
                </div>
              </td>
            </tr>
            <tr className={tw`bg-gray-200 font-semibold`}>
              <td className={tw`py-2 px-5`}>{dayjs().format("YY/MM/DD")}</td>
              <td></td>
              <td></td>
              <td className={tw`py-2 px-5`}>Closing Balance</td>
              <td className={tw`py-2  `}>
                <div className={tw`flex justify-around w-full`}>
                  <span>
                    {Number(closingQty.toFixed(2)).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  <span></span>
                  <span></span>
                </div>
              </td>
              <td></td>
            </tr>
          </Fragment>
        );
      })}
    </tbody>
  );
}
